import authService from './authService';
import mockAuthService from '../mock/mockAuthService';

// Conditionally export the real or mock service based on environment
const useMockService = process.env.REACT_APP_ENABLE_MOCK_API === 'true';

// Export the appropriate service
export default useMockService ? mockAuthService : authService;
